import React, { Component, ErrorInfo } from 'react'
import { reportError } from 'utils/errorReporting'

const ErrorContent = ({ error, ...props }: any) => (
  <div {...props}>
    <h1>Error</h1>
    <p>{error}</p>
  </div>
)

class ErrorBoundary extends Component {
  state = {
    hasError: false,
    errorText: 'Something went wrong'
  }

  static getDerivedStateFromError(error: string) {
    return { hasError: true, errorText: error }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    reportError({ source: 'ErrorBoundary', error, info: errorInfo })
  }
  
  render() {
    const { children } = this.props
    const isErrorPage = window.location?.pathname === '/error'
    const is404 = window.location?.pathname === '/404'
    
    if (is404) return <ErrorContent error={'404'} />
    if (isErrorPage || this.state.hasError) return <ErrorContent error={this.state.errorText} />
    return children
  }
}

export default ErrorBoundary as any
